import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ReactNode } from 'react'
import AnimateHeight from 'react-animate-height'
import styled from 'styled-components'

import { AccordionIcon, Column, FlexColumn, MaxColumn } from '@/components/StyledComponents'

const TextColumn = styled(MaxColumn)`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: left;
  margin-left: 10px;
  min-width: 0;
`

const ButtonRow = styled(DisclosureButton)`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  border: 0;
  flex: 1;
  width: 100%;
  cursor: pointer;
`

const Title = styled.div`
  font-weight: bold;
`

const Subtitle = styled.div`
  font-size: 13px;
  color: #707070;
`

interface Props {
  title?: string | ReactNode
  subtitle?: string | ReactNode
  icon?: (isOpen: boolean) => ReactNode
  children: ReactNode
  onToggle?: (isOpen: boolean) => void
  defaultOpen?: boolean
  alignLeft?: boolean
  className?: string
}

// TODO Migrate to tailwindcss to use the animations and styles that are built in
const Accordion = ({ title, subtitle, icon, children, defaultOpen = false, alignLeft = false, className }: Props) => {
  return (
    <Column className={className}>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <ButtonRow>
              <FlexColumn>{icon ? icon(open) : <AccordionIcon isOpen={open} alignLeft={alignLeft} />}</FlexColumn>
              <TextColumn>
                {subtitle ? (
                  <>
                    <Title>{title}</Title>
                    <Subtitle>{subtitle}</Subtitle>
                  </>
                ) : (
                  title
                )}
              </TextColumn>
            </ButtonRow>

            <AnimateHeight duration={200} height={open ? 'auto' : 0}>
              <DisclosurePanel static>
                <MaxColumn>{children}</MaxColumn>
              </DisclosurePanel>
            </AnimateHeight>
          </>
        )}
      </Disclosure>
    </Column>
  )
}

export default Accordion
